import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceOutcomeTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupOutcome = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceOutcomeTypes.OutcomeLookupDataType): AxiosPromise<serviceOutcomeTypes.OutcomeLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.outcome.lookupOutcome), {
    blockSpinner,
  });
};

export const lookupOutcomeTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceOutcomeTypes.OutcomeLookupDataType): AxiosPromise<serviceOutcomeTypes.OutcomeTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.outcome.lookupOutcome), {
    blockSpinner,
  });
};

export const createOutcome = (
  form: serviceOutcomeTypes.OutcomeCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceOutcomeTypes.OutcomeCreateResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const processesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.outcomeNumber) {
    formData.append('outcomeNumber', form.outcomeNumber);
  }

  if (form.outcomeName) {
    formData.append('outcomeName', form.outcomeName);
  }

  if (form.relatedInjection) {
    formData.append('relatedInjection', form.relatedInjection);
  }

  // if (form.relatedInjectionDateTime) {
  //   formData.append('relatedInjectionDateTime', form.relatedInjectionDateTime.toString());
  // }

  if (form.relatedAction) {
    formData.append('relatedAction', form.relatedAction);
  }

  // if (form.relatedActionDateTime) {
  //   formData.append('relatedActionDateTime', form.relatedActionDateTime.toString());
  // }
  if (form.timeDetails) {
    formData.append('timeDetails', JSON.stringify(form.timeDetails));
  }

  if (form.type) {
    formData.append('type', form.type.toString());
  }

  if (form.relatedAudienceEntities) {
    form.relatedAudienceEntities.forEach((e) => formData.append('relatedAudienceEntities', e as any as string));

    // formData.append('relatedAudienceEntities', entitiesData);
  }

  if (form.relatedAudienceProcesses.length > 0) {
    form.relatedAudienceProcesses.forEach((e) => formData.append('relatedAudienceProcesses', e as any as string));
    // formData.append('relatedAudienceProcesses', processesData);
  }

  if (form.workloadOnAudience) {
    formData.append('workloadOnAudience', form.workloadOnAudience.toString());
  }

  if (form.outcomeDirection) {
    formData.append('outcomeDirection', form.outcomeDirection);
  }

  if (form.weightInTOAchievement) {
    formData.append('weightInTOAchievement', form.weightInTOAchievement.toString());
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.outcomeStatusId) {
    formData.append('outcomeStatusId', form.outcomeStatusId);
  }

  if (form.outcomeOverwrittenValue) {
    formData.append('outcomeOverwrittenValue', String(form.outcomeOverwrittenValue));
  }

  formData.append('isInternal', form.isInternal.toString());

  formData.append('enableObservationTaskShortcut', String(form.enableObservationTaskShortcut));

  return axios.post(urlsConfig.outcome.createOutcome, formData, { blockErrorHandler: true });
};

export const outcomeEdit = (
  form: serviceOutcomeTypes.OutcomeEditDataType,
  // formData: FormData,
): AxiosPromise<serviceOutcomeTypes.OutcomeEditResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const processesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (form.deletedAttachments !== undefined) {
    form.deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.outcomeNumber) {
    formData.append('outcomeNumber', form.outcomeNumber);
  }

  if (form.outcomeName) {
    formData.append('outcomeName', form.outcomeName);
  }

  if (form.relatedInjection) {
    formData.append('relatedInjection', form.relatedInjection);
  }

  // if (form.relatedInjectionDateTime) {
  //   formData.append('relatedInjectionDateTime', form.relatedInjectionDateTime.toString());
  // }

  if (form.relatedAction) {
    formData.append('relatedAction', form.relatedAction);
  }
  if (form.timeDetails) {
    formData.append('timeDetails', JSON.stringify(form.timeDetails));
  }

  if (form.type) {
    formData.append('type', form.type.toString());
  }

  // if (form.relatedActionDateTime) {
  //   formData.append('relatedActionDateTime', form.relatedActionDateTime.toString());
  // }

  if (form.relatedAudienceEntities) {
    form.relatedAudienceEntities.forEach((e) => formData.append('relatedAudienceEntities', e as any as string));

    // formData.append('relatedAudienceEntities', entitiesData);
  }

  if (form.relatedAudienceProcesses.length > 0) {
    form.relatedAudienceProcesses.forEach((e) => formData.append('relatedAudienceProcesses', e as any as string));
    // formData.append('relatedAudienceProcesses', processesData);
  }

  if (form.workloadOnAudience) {
    formData.append('workloadOnAudience', form.workloadOnAudience.toString());
  }

  if (form.weightInTOAchievement) {
    formData.append('weightInTOAchievement', form.weightInTOAchievement.toString());
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  if (form.outcomeStatusId) {
    formData.append('outcomeStatusId', form.outcomeStatusId);
  }
  if (form.outcomeDirection) {
    formData.append('outcomeDirection', form.outcomeDirection);
  }
  formData.append('isInternal', form.isInternal.toString());

  formData.append('enableObservationTaskShortcut', String(form.enableObservationTaskShortcut));

  if (form.enableObservationTaskShortcut && form.outcomeOverwrittenValue != undefined) {
    formData.append('outcomeOverwrittenValue', String(form.outcomeOverwrittenValue));
  }

  return axios.patch(urlsConfig.outcome.outcomeEdit, formData, { blockErrorHandler: true });
};

export const outcomeEditOverwrite = ({
  id,
  outcomeOverwrittenValue,
}: serviceOutcomeTypes.OutcomeEditOverwriteDataType): AxiosPromise<serviceOutcomeTypes.OutcomeEditOverwriteResultType> => {
  return axios.patch(urlsConfig.outcome.outcomeEditOverwrite, { id, outcomeOverwrittenValue });
};

export const outcomeDelete = ({
  id,
}: serviceOutcomeTypes.OutcomeDeleteDataType): AxiosPromise<serviceOutcomeTypes.OutcomeDeleteResultType> => {
  return axios.delete(`${urlsConfig.outcome.outcomeDelete}/${id}`);
};
